"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundProtect = void 0;
const react_1 = __importStar(require("react"));
require("./RefundProtect.scss");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const FormSuite_1 = require("../../hooks/FormSuite");
const numbers_1 = require("../../utils/numbers");
const helpers_1 = require("../../utils/helpers");
const message_utils_1 = __importDefault(require("../../utils/message_utils"));
const suiteCollapseStyle_1 = require("../suiteCollapse/suiteCollapseStyle");
const ConfirmValuesContext_1 = require("../../pages/paymentBooking/context/ConfirmValuesContext");
const refundCasesText = [
    'Doença, Acidente, Ferimentos',
    'Falha do Transporte Público',
    'Falha com Veículo Privado',
    'Emergência Doméstica',
    'Roubo de Documentos',
    'Chamada Serviços de Emergência',
    'Condições Médicas Pré-existentes',
    'Intimação Judicial',
    'E muito mais',
];
const RefundProtect = ({ formKey, field, setPaymentEnabled, setShowRefundComponent, showRefundComponent, refundProtectEnabled, }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const { form } = (0, FormSuite_1.useFormSuit)();
    const [refundPrice, setRefundPrice] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        var _a;
        // Atualiza o checkbox quando a página é inicializada ou atualizada
        const { confirmValues } = confirmValuesContext;
        const formValues = form.getFieldsValue();
        const refundPriceValue = confirmValuesContext.confirmValues.originalTotalPrice * ConfirmValuesContext_1.refundPercentage;
        if (confirmValues.isCheckedRefund === undefined) {
            // Inicialmente começa selecionado como true
            formValues[formKey][0].refundProtect = true;
            formValues[formKey][0].refundPrice = refundPriceValue.toFixed(2);
            confirmValuesContext.updateTotalPrice((_a = confirmValues === null || confirmValues === void 0 ? void 0 : confirmValues.coupon) === null || _a === void 0 ? void 0 : _a.phrase, true);
        }
        else {
            // Ultima seleção escolhida
            formValues[formKey][0].refundProtect = !!confirmValues.refundPrice;
            formValues[formKey][0].refundPrice = (confirmValues.refundPrice || 0).toFixed(2);
        }
        form.setFieldsValue(formValues);
        // Valor fixo do refund a ser mostrado
        setRefundPrice(refundPriceValue);
    }, []);
    const handleOptionChange = (0, react_1.useCallback)((selectedOption) => {
        var _a;
        const formValues = form.getFieldsValue();
        if (selectedOption.target.value) {
            formValues[formKey][0].refundProtect = selectedOption.target.value;
            formValues[formKey][0].refundPrice = refundPrice.toFixed(2);
        }
        else {
            formValues[formKey][0].refundProtect = selectedOption.target.value;
            formValues[formKey][0].refundPrice = 0;
        }
        form.setFieldsValue(formValues);
        // Refaz o cálculo dos valores
        const { confirmValues } = confirmValuesContext;
        const formRefundProtectFieldValue = form.getFieldValue([formKey, 0, 'refundProtect']);
        confirmValuesContext.updateTotalPrice((_a = confirmValues === null || confirmValues === void 0 ? void 0 : confirmValues.coupon) === null || _a === void 0 ? void 0 : _a.phrase, formRefundProtectFieldValue);
    }, [form, formKey, refundPrice, confirmValuesContext]);
    const showForm = (0, react_1.useCallback)(() => {
        setShowRefundComponent(!showRefundComponent);
    }, [showRefundComponent]);
    const validationForm = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const refundValidate = new Promise((resolve, reject) => {
            const refundOptionField = form.getFieldValue([formKey, field, 'refundProtect']);
            if (refundOptionField === undefined)
                form
                    .validateFields([[formKey, field, 'refundProtect']])
                    .then(() => {
                    resolve(true);
                })
                    .catch(error => {
                    if (error.errorFields && error.errorFields.length > 0) {
                        reject(error);
                    }
                    resolve(true);
                });
            else
                resolve(true);
        });
        yield Promise.all([refundValidate])
            .then(() => {
            setShowRefundComponent(false);
            setPaymentEnabled(false);
        })
            .catch(error => {
            const descriptionElement = (0, helpers_1.messageErrorsValidationsFieldsCheckin)(error);
            message_utils_1.default.error({
                message: descriptionElement,
            });
        });
    }), [form]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Col, { xs: {
                span: 24,
                flex: '1',
            }, sm: {
                span: 24,
                flex: '1',
            }, lg: 11 },
            react_1.default.createElement(suiteCollapseStyle_1.ButtomSuiteForm, { onClick: showForm, type: "primary", icon: react_1.default.createElement(icons_1.CaretDownOutlined, null), disabled: !refundProtectEnabled },
                react_1.default.createElement(antd_1.Row, { className: "refund-component-button-suite-form" },
                    react_1.default.createElement(icons_1.SafetyCertificateFilled, null),
                    "Refund Protect"))),
        react_1.default.createElement(suiteCollapseStyle_1.FormBody, { showForm: showRefundComponent },
            react_1.default.createElement("div", { className: "refund-component" },
                react_1.default.createElement(antd_1.Form.Item, { name: [field, 'refundProtect'] },
                    react_1.default.createElement(antd_1.Radio.Group, { onChange: selectedOption => handleOptionChange(selectedOption), defaultValue: true },
                        react_1.default.createElement("div", { className: "accept-refund" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(antd_1.Radio, { value: true },
                                    react_1.default.createElement(icons_1.SafetyCertificateFilled, null),
                                    react_1.default.createElement("span", null, "Reserva reembols\u00E1vel"),
                                    react_1.default.createElement("span", { className: "recommended-span" }, "Recomendado"))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", { className: "price" }, `${(0, numbers_1.formatCurrency)(refundPrice)}`))),
                        react_1.default.createElement("div", { className: "about-covid" },
                            react_1.default.createElement(icons_1.CheckOutlined, null),
                            react_1.default.createElement("span", null,
                                "COVID-19 infec\u00E7\u00E3o e Isolamento -\u00A0",
                                react_1.default.createElement("a", { href: "https://www.refundable.me/extended/pt-br/", target: "_blank", className: "about-covid-details", rel: "noreferrer" }, "Ver detalhes"))),
                        react_1.default.createElement("div", { className: "refund-details" }, refundCasesText.map(content => (react_1.default.createElement("div", null,
                            react_1.default.createElement(icons_1.CheckOutlined, null),
                            react_1.default.createElement("span", null, content))))),
                        react_1.default.createElement("div", { className: "refund-terms" },
                            react_1.default.createElement("span", null,
                                "Fa\u00E7a um upgrade na sua reserva e tenha um\u00A0",
                                react_1.default.createElement("b", null, "reembolso total"),
                                "\u00A0se voc\u00EA n\u00E3o puder comparecer em fun\u00E7\u00E3o dos motivos listados em nossos\u00A0",
                                react_1.default.createElement("a", { href: "https://www.refundable.me/extended/pt-br/", target: "_blank", className: "terms-link", rel: "noreferrer" }, "Termos e Condi\u00E7\u00F5es,"),
                                "\u00A0o qual voc\u00EA aceita ao selecionar a op\u00E7\u00E3o de Reserva Reembols\u00E1vel.")),
                        react_1.default.createElement("div", { className: "refuse-refund" },
                            react_1.default.createElement(antd_1.Radio, { value: false },
                                react_1.default.createElement(icons_1.SafetyCertificateOutlined, null),
                                react_1.default.createElement("span", null, "Reserva n\u00E3o reembols\u00E1vel."))))),
                react_1.default.createElement(antd_1.Form.Item, { name: [0, 'save'] },
                    react_1.default.createElement(antd_1.Button, { type: "primary", onClick: validationForm, className: "btn-save", style: { textAlign: 'center', marginTop: '15px' } }, "Salvar"))))));
};
exports.RefundProtect = RefundProtect;
